import * as R from 'ramda'
import WappRunner from 'weblite-web-wapprunner'
import { getWapp } from '$logic/wapps/service'
import { wappVersionByIdView } from '$logic/wapps/wapps.reducer'
import { nothing } from '$func/utils'

export function WappRunnerProvider({ children }: { children: JSX.Element }) {
  const props = {
    getWappVersion: wappVersionByIdView,

    getWappServIndexesAsync: (wappId: string) =>
      getWapp(wappId).then(R.prop('servIndexes')),

    disableConfirmationOnBackClick: nothing, // TODO: Implement me
  }

  return <WappRunner {...props}>{children}</WappRunner>
}
